import { format } from 'date-fns';
import * as React from 'react';
import { Modal } from 'react-bootstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { deletePlantDetails } from '../../../actions/dashboardAction';
import { hidePlantListModal } from '../../../actions/modalActions';
import { IFlaggedFormDetails, IIDs, IQuestions } from '../../../interfaces';
import { markAsComplete } from '../../../services/dailyFormService';
import { Alert } from '../Alert';
import { Async } from '../Async';
import { RDatePicker } from '../DatePicker';
import { ErrorPage } from '../ErrorPage';
import { Loader } from '../Loader';
import { IHistory } from '../../../interfaces';

import './listModal.scss';
import { questionData, inspectionType  } from '../../../constants/generals';

export interface IDetailsModalProps {
    id: string;
    modalID?: string;
    dateCompleted?: string;
    modalTitle: string;
    listHeadings: string[];
    listItemComponent: React.ComponentClass<{
        index: number, UniqueId?: string, plantId?: string | IFlaggedFormDetails,
        onClick(UniqueId: string, type: string): void, userId?: string, formType?: string;
        Region: string, State: string, Completed?: boolean; UserName: string; formId: string
    }>;
    ids?: IIDs[];
    className?: string;
    style?: React.CSSProperties;
    listTitle?: string;
    promise?(datePlant: string, type: string): any;
    initialPromise?: any;
    formDetails?: IQuestions[];
    formType?: string;
    userId?: string;
    completedBy?: string;
    followUpComment?: string;
    history?: IHistory;

}

export interface IDetailsModalState {
    showDetails: boolean;
    showProgressBar: boolean;
    plantID: string;
    UniqueId: string;
    DateCompleted: string;
    isLoading: boolean;
    formType: string;
    index?: number;
    showMarkAsCompleteButtonFor?: number;
    comments: string;
    ids: IIDs[];
    quesNum: number;
    date: Date;
}

export class DetailsModalImpl extends React.Component<IDetailsModalProps, IDetailsModalState> {
    constructor(props: IDetailsModalProps) {
        super(props);
        this.state = {
            showDetails: false, plantID: null, showProgressBar: false, DateCompleted: '',
            UniqueId: '', formType: '', isLoading: false, comments: '', date: new Date(),
            ids: props.ids, quesNum: null, showMarkAsCompleteButtonFor: null
        };
    }

    static defaultProps: IDetailsModalProps;

    handleMarkComplete = async () => {
        if (this.state.comments.length <= 0) {
            toast.error('Please enter comments first..!', {
                position: toast.POSITION.TOP_CENTER,
                className: 'failed-toast'
            });
            return;
        }
        const type = (this.state.formType === 'Daily Form' ? 'dailyForm' : this.state.formType);
        const { state: { comments, formType, date, quesNum, UniqueId }, props: { userId } } = this;
        this.setState({
            isLoading: true
        });
        await markAsComplete(comments, UniqueId, type, quesNum, format(date, 'MM-DD-YYYY'), this);
        this.setState({
            isLoading: false,
            showDetails: false
        });
    }

    renderFormDetails = () => {
        const { formDetails } = this.props;
        const permanentData = formDetails && formDetails.slice(0, 4);
        const questions = formDetails && formDetails.slice(4); 
        if (!formDetails) {
            return <div></div>;
        }
        return <PerfectScrollbar>
            { permanentData && permanentData.map((questionData, index) => (
                [<Label
                key={122}
                icon={<i className="fa fa" aria-hidden="true">&nbsp;</i>}
                isFlagged={1}>{questionData.question}
                </Label>,
                <Value key={333} >&nbsp; {questionData.question=='Form Type'?inspectionType(questionData.answer):(questionData.answer || 'Unanswered')}</Value>,
                <span key={1213} style={{ display: 'block', paddingBottom: '20px' }} />,
            ]
            ))
            }
            {questions.map((questionData, index) => {
                const isComment = questionData.question.toLocaleString().toLowerCase() === 'comments:';
                const isCompleted = questionData.completed;
                if (isCompleted) {
                    return [
                        <Label
                            key={122}
                            icon={<i className="fa fa-flag" aria-hidden="true">&nbsp;</i>}
                            isFlagged={true}>{questionData.question}
                        </Label>,
                        <Value key={333} >{questionData.answer || 'Unanswered'}</Value>,
                        <span key={1213} style={{ display: 'block', paddingBottom: '20px' }} />,
                        <Label
                            icon={<i className="fa fa-check-circle" aria-hidden="true">&nbsp;</i>}
                            key={1} isFlagged={1} >Completed By:
                        </Label>,
                        <Value key={2}>{questionData.completedBy || 'NA'}</Value>,
                        <span key={6} style={{ display: 'block', paddingBottom: '20px' }} />,
                        <Label
                            icon={<i className="fa fa-comments" aria-hidden="true">&nbsp;</i>}
                            key={4} isFlagged={1} >Follow Up Comments:
                        </Label>,
                        <Value key={5}>{questionData.followUpComments || 'NA'}</Value>,
                        <span key={7} style={{ display: 'block', paddingBottom: '20px' }} />,
                        <Label
                            icon={<i className="fa fa-calendar" aria-hidden="true">&nbsp;</i>}
                            key={8} isFlagged={1} >Date Completed:
                        </Label>,
                        <Value key={9}>{questionData.dateCompleted || 'NA'}</Value>,
                        <span key={10} style={{ display: 'block', paddingBottom: '20px' }} />
                    ];
                }
                return <div key={index} style={{ paddingBottom: '20px' }}>
                    <div className="flagged-question-container" >
                        {isComment ? '' :
                            <div className="mark-as-complete-col" >
                                <i
                                    className="fa fa-check-square-o"
                                    onClick={() => this.setState({
                                        quesNum: questionData.quesNum,
                                        showMarkAsCompleteButtonFor:
                                            this.state.showMarkAsCompleteButtonFor === index ? null : index
                                    })}
                                    aria-hidden="true">
                                </i>

                            </div>
                        }
                        <div>
                            <Label
                                icon={<i className="fa fa-flag" aria-hidden="true">&nbsp;</i>}
                                isFlagged={true}>{questionData.question}
                            </Label>
                            <Value>{questionData.answer || 'Unanswered'}</Value>
                        </div>
                    </div>
                    <div
                        className="flagged-input-container"
                        style={{
                            height: this.state.showMarkAsCompleteButtonFor === index ? '141px' : '0px',
                            opacity: this.state.showMarkAsCompleteButtonFor === index ? 1 : 0,
                            overflow: this.state.showMarkAsCompleteButtonFor === index ? 'unset' : 'hidden',
                            textAlign: 'center', marginBottom: '20px'
                        }}>
                        <span style={{ color: '#b7b7b7', fontWeight: 'bold' }}  >Select Date:</span>
                        <RDatePicker
                            value={this.state.date}
                            onChange={date => this.setState({ date })}
                        />
                        <div className="add-comments-section">
                            <textarea
                                rows={3}
                                placeholder="Enter your comments..."
                                onChange={e => this.setState({ comments: e.target.value })}
                            />
                        </div>
                        <button className="mark-as-complete-button"
                            onClick={this.handleMarkComplete}
                        >
                            Mark as Complete
            </button>
                    </div>
                </div>;
            })}
        </PerfectScrollbar>;
    }

    showPlantDetails = () => {
        const type = (this.state.formType === 'Daily Form' ? 'dailyForm' : this.state.formType);
        return <Async
            identifier="LitModal"
            promise={() => this.props.promise(this.state.UniqueId, type)}
            loader={<Loader type="async" />}
            error={<ErrorPage />}
            content={this.renderFormDetails()}
        />;
    }

    handleOnListItemClick = (UniqueId, DateCompleted, formType, index) => {
        this.setState({ showDetails: true, UniqueId, DateCompleted, formType, index });
    }

    showPlantList = () => {
        const { ids, listItemComponent, listTitle } = this.props;
        const ListItem = listItemComponent;
        return ids.length > 0 ? ids.map((data, index) => {
            return <ListItem
                index={index}
                key={index}
                plantId={data.PlantId}
                userId={data.UserId}
                onClick={() => this.handleOnListItemClick(data.UniqueId, data.Date, data.Type, index)}
                formType={data.Type || data.FormId}
                UniqueId={data.UniqueId}
                State={data.State}
                Region={data.Region}
                UserName={data.UserName}
                formId={data.FormId}
                Completed={data.Completed > 0}
            />;
        }) : <div
            style={{
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: '16px',
                color: 'gray',
                textAlign: 'center'
            }} >
                No {listTitle} found.
            </div>;
    }

    hideModal = () => {
        hidePlantListModal();
        deletePlantDetails();
        this.setState({
            showDetails: false
        });
    }

    renderContent = () => {
        const { listHeadings } = this.props;
        return <Modal.Body style={{ backgroundColor: 'black', border: '1px solid #757575' }} >
            {this.state.isLoading ? <Loader type="submission" /> : ''}
            <Alert id="incomplete-list-update" />
            {this.state.showDetails ? '' :
                <div className="heading-container" >{listHeadings.map((heading, index) => {
                    return <div
                        key={index}
                        className="heading"
                        style={{ width: `${20}%` }}
                    >
                        {heading}
                    </div>;
                })}</div>
            }
            {this.state.showDetails ?
                this.showPlantDetails() :
                <div className="list-items">
                    <PerfectScrollbar>
                        {this.showPlantList()}
                    </PerfectScrollbar>
                </div>}
        </Modal.Body>;
    }

    renderModalBody = () => {
        if (this.props.initialPromise) {
            return <Async
                identifier="InitialPromiseDetailsModal"
                promise={this.props.initialPromise()}
                loader={<Loader type="async" />}
                error={<ErrorPage />}
                content={this.renderContent()}
            />;
        }
        return this.renderContent();
    }

    renderListItems = () => {
        const { id, ids, style, listTitle, className, modalTitle, modalID,
            listItemComponent, listHeadings } = this.props;
        if (id !== modalID) {
            return <div></div>;
        }
        return <Modal
            show={true}
            className={`${className} list-modal`}
            style={style}
            onHide={this.hideModal}
            aria-labelledby="contained-modal-title"
        >
            <Modal.Header closeButton style={modalHeader} >
                <Modal.Title id="contained-modal-title" style={{ color: 'white' }} >
                    {this.state.showDetails ?
                        <div className="back-button" onClick={() => this.setState({ showDetails: false })} >
                            <i style={{
                                fontSize: '22px', paddingRight: '10px'
                            }} className="fa fa-arrow-circle-left" aria-hidden="true"></i>

                            {`Details Of Flagged ${inspectionType(this.state.formType)}`}
                        </div> : listTitle}
                </Modal.Title>
            </Modal.Header>
            {this.renderModalBody()}
        </Modal>;
    }

    render() {
        return this.renderListItems();
    }

}

export function mapStateToProps(state, ownProps) {
    return {
        modalID: state.modal.get('listModalID'),
        userId: state.login.get('userId'),
        ids: state.modal.get('listData'),
        listTitle: state.modal.get('listTitle'),
        formType: state.modal.get('formType'),
        formDetails: state.dashboard.get('flaggedFormDetails'),
        followUpComment: state.dashboard.get('followUpComments'),
        completedBy: state.dashboard.get('completedBy'),
        dateCompleted: state.dashboard.get('dateCompleted'),
    };
}

export const DetailsModal = connect<{}, {}, IDetailsModalProps>(mapStateToProps)(DetailsModalImpl as any);

const modalHeader: React.CSSProperties = {
    backgroundColor: '#A4BF43',
    border: 'none',
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px'
};

const Label = ({ children, isFlagged, icon }) => {
    return <div
        style={{ fontSize: '18px', color: `${isFlagged ? '#A4BF43' : 'gray'}` }}
    >
        {isFlagged ?
            icon
            : ''}
        {children}
    </div>;
};

const Value = ({ children }) => {
    return <div style={{ fontSize: '18px', color: 'white' }} >{children}</div>;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/ListModal/DetailsModal.tsx